import React, { useState } from 'react';

import { Modal } from 'antd';

import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Button from '@/common/components/button/button.component';
import FixedBottom from '@/common/components/fixed-bottom';

import Close from '~/public/assets/images/svg/close-line.svg';

interface Props {
  availability?: string;
  addToCart: () => void;
  isPending: boolean;
  isOrderBlocked: boolean | undefined;
}

const Buttons = ({
  availability,
  addToCart,
  isPending,
  isOrderBlocked,
}: Props) => {
  const [open, setOpen] = useState(false);
  const closeModalHandler = () => {
    setOpen(false);
  };
  const openModalHandler = () => {
    setOpen(true);
  };

  if (isPending) return;

  return (
    <>
      {availability === 'OutOfStock' ? (
        <FixedBottom className="lg:static lg:!inset-auto lg:!mx-0 lg:!h-auto lg:!w-full lg:!max-w-none lg:!border-t-0 lg:!bg-transparent lg:!px-0 lg:!py-0">
          <Button
            className="!h-11 w-full !bg-black-100 !text-white"
            type="black"
            disabled
          >
            ناموجود
          </Button>
        </FixedBottom>
      ) : (
        <FixedBottom className="lg:static lg:!inset-auto lg:!mx-0 lg:!h-auto lg:!w-full lg:!max-w-none lg:!border-t-0 lg:!bg-transparent lg:!px-0 lg:!py-0">
          <AnalyticsWrapper analytics={['product-submit-add-to-cart-v1']}>
            <Button
              id="product-submit-add-to-cart-v1"
              type="black"
              onClick={isOrderBlocked ? openModalHandler : addToCart}
              loading={isPending}
              className="!h-11 w-full"
            >
              افزودن به سبد خرید
            </Button>
          </AnalyticsWrapper>
        </FixedBottom>
      )}
      <Modal
        className="max-w-[504px]"
        open={open}
        onCancel={closeModalHandler}
        centered
        closable={false}
        footer={null}
      >
        <div onClick={closeModalHandler}>
          <Close className="mr-auto h-6 w-6 cursor-pointer text-secondary-300" />
        </div>
        <div className="mb-3 mt-12 px-6">
          <p className="mb-[70px] text-center text-lg font-semibold text-black-500">
            فعلا امکان ثبت سفارش از این فروشگاه وجود نداره!
          </p>
          <Button onClick={closeModalHandler} className="w-full" type="black">
            متوجه شدم
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Buttons;
